import React from 'react';
import '../LegalPage/LegalPage.scss';

export default function CommunityGuidelines() {
  return (
    <main className="legal-page">
      <section className="legal-page__hero">
        <p className="legal-page__eyebrow">The Tour Golfers</p>
        <h1>Community Guidelines</h1>
        <p>Effective Date: May 2026</p>
      </section>

      <section className="legal-page__content">
        <p>
          The Tour Golfers is built to be a digital country club for public golfers.
          These Community Guidelines help keep the platform respectful, useful, and
          safe.
        </p>

        <h2>1. Be Respectful</h2>
        <ul>
          <li>Treat other members with respect</li>
          <li>No harassment, bullying, threats, or intimidation</li>
          <li>No hateful, discriminatory, or degrading behavior</li>
        </ul>

        <h2>2. Share Responsibly</h2>
        <ul>
          <li>Only upload content you own or have permission to share</li>
          <li>Do not upload explicit, offensive, misleading, or harmful material</li>
          <li>Do not impersonate another golfer, course, brand, or organization</li>
        </ul>

        <h2>3. Keep Golf Honest</h2>
        <ul>
          <li>Submit accurate scores and round activity</li>
          <li>Do not manipulate tournaments, groups, leaderboards, or stats</li>
          <li>Do not use the platform to spam or mislead other members</li>
        </ul>

        <h2>4. Reporting and Blocking</h2>
        <p>
          Members can report content or users that violate these Guidelines. Members
          may also block other users to prevent further unwanted interaction.
        </p>

        <h2>5. Enforcement</h2>
        <p>Violations may result in:</p>
        <ul>
          <li>Content removal</li>
          <li>Hidden or restricted posts/comments</li>
          <li>Account warnings</li>
          <li>Temporary or permanent suspension</li>
        </ul>

        <h2>6. Contact</h2>
        <p>
          Community safety concerns can be sent to{' '}
          <a href="mailto:support@thetourgolfers.com">support@thetourgolfers.com</a>.
        </p>
      </section>
    </main>
  );
}